module.exports = __webpack_public_path__ + "static/img/pic_pctopdaoshi@2x.30260b28.png";